import { Grid, Text } from '@mantine/core';
import { isString } from 'lodash';
import * as React from 'react';
import { DialogSize } from '../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { formatIdentifier } from '../../../../../../react-commons/utils/utilFunctions';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    MutationErrorResponse,
    MutationSuccessResponse,
    MutationSuccessResponseOfBatchAdd,
} from '../../../../resource/resources/validation/errorResponseResource';
import { MutationValidationResource } from '../../../../resource/resources/validation/mutationValidationResource';
import { PersistableCreationResultSet } from '../../../../resource/resources/validation/persistableCreationResultSet';
import { MutationValidationResultComponent } from './MutationValidationResultComponent';
import { PersistableCreationResultSetComponent } from './PersistableCreationResultSetComponent';

export const ErrorResponseComponent= ({ errorResponse, resourceType, dialogSize }: {
    errorResponse:
        | MutationSuccessResponse
        | MutationSuccessResponseOfBatchAdd
        | MutationErrorResponse
        | null
        | undefined;
    resourceType: ResourceType;
    dialogSize?: DialogSize;
}) => {
    const getRows = (): number => {
        const dividerNumber = () => {
            if (dialogSize) {
                switch (dialogSize) {
                    case DialogSize.LARGE:
                        return 200;
                    case DialogSize.MEDIUM_LARGE:
                        return 120;
                    case DialogSize.MEDIUM:
                        return 80;
                    case DialogSize.SMALL_MEDIUM:
                        return 50;
                    case DialogSize.SMALL:
                        return 20;
                }
            }
            return 200;
        };

        if (
            errorResponse &&
            'message' in errorResponse &&
            errorResponse.message &&
            typeof errorResponse.message === 'string'
        ) {
            if (errorResponse.message.includes('\n')) {
                const splitByNewLine = errorResponse.message.split('\n');
                let lineCount = 1;
                for (const line of splitByNewLine) {
                    let dividedNumber = line.length / dividerNumber();
                    if (dividedNumber === 0) {
                        dividedNumber = 1;
                    }
                    lineCount = lineCount + dividedNumber;
                }
                return Math.min(lineCount, 25);
            }
            return (
                errorResponse.message.length / 200 < 3 ? 3
                : errorResponse.message.length / 200 > 25 ? 25
                : errorResponse.message.length / 200
            );
        }
        return 25;
    };

    return (
        <Grid>
            {errorResponse &&
                'exceptionType' in errorResponse &&
                Boolean(errorResponse.exceptionType) &&
                isString(errorResponse.exceptionType) && (
                    <Grid.Col span={12}>
                        <div style={{ display: 'inline-flex', width: '100%' }}>
                            <Text style={{ minWidth: 200 }}>Exception Type</Text>
                            <ControlledInputs.String
                                nullable={false}
                                readOnly={true}
                                value={formatIdentifier(errorResponse.exceptionType)}
                            />
                        </div>
                    </Grid.Col>
                )}
            {errorResponse?.type && errorResponse.type !== 'MUTATION' && errorResponse.type !== 'BATCH_ADD' && (
                <Grid.Col span={12}>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <Text style={{ minWidth: 200 }}>Type</Text>
                        <ControlledInputs.String
                            nullable={false}
                            readOnly={true}
                            value={formatIdentifier(errorResponse.type)}
                        />
                    </div>
                </Grid.Col>
            )}
            {errorResponse &&
                'right' in errorResponse &&
                Boolean(errorResponse.right) &&
                isString(errorResponse.right) && (
                    <Grid.Col span={12}>
                        <div style={{ display: 'inline-flex' }}>
                            <Text style={{ minWidth: 200 }}>Missing Right</Text>
                            <ControlledInputs.String nullable={false} readOnly={true} value={errorResponse.right} />
                        </div>
                    </Grid.Col>
                )}
            {errorResponse && 'message' in errorResponse && Boolean(errorResponse.message) && (
                <Grid.Col span={12}>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <Text style={{ minWidth: 200 }}>Exception Message</Text>
                        <ControlledInputs.MultilineString
                            nullable={false}
                            readOnly={true}
                            value={errorResponse.message as string}
                        />
                    </div>
                </Grid.Col>
            )}
            {errorResponse?.content && errorResponse?.type !== 'BATCH_ADD' && (
                <Grid.Col span={12}>
                    <MutationValidationResultComponent
                        resourceValidation={errorResponse.content as MutationValidationResource}
                        resourceType={resourceType}
                    />
                </Grid.Col>
            )}
            {errorResponse?.content && errorResponse?.type === 'BATCH_ADD' && (
                <Grid.Col span={12}>
                    <PersistableCreationResultSetComponent
                        resultSet={errorResponse.content as PersistableCreationResultSet}
                        resourceType={resourceType}
                    />
                </Grid.Col>
            )}
        </Grid>
    );
};


